import React from "react";
import SectionBar from "../components/SectionBar";
import { size } from "lodash";
import { assessmentFlow, AccountType } from "../../components/constants/constants";

const Sidebar = ({
  setCurrentSectionPage,
  data,
  currentPage,
  setCurrentPage,
  answers,
}) => {
  // const ClickOnPart = (props) => {
  //   setCurrentPage(props);
  //   setCurrentSectionPage(parseInt(`${props}${1}`));
  //   if (props > currentPage) {
  //     if (isAiGradingexercise && data?.is_premium && AisubmissionCounter > 0) {
  //       setAisubmissionCounter(parseInt(`${AisubmissionCounter - 1}`));
  //     }
  //   } else if (props < currentPage) {
  //     if (AisubmissionCounter < data?.remaining_credits) {
  //       setAisubmissionCounter(parseInt(`${AisubmissionCounter + 1}`));
  //     }
  //   }
  // };
  let standing_page = currentPage;
  if(data.assessment_flow === assessmentFlow.SEQUENTIAL_EARLY_STOP && data.user_type === AccountType.STUDENT)
  {
    standing_page = size(data.sections) > 0 ? data.sections[0].section_number : 1
  }

  return (
    <div className="p-4">
      {data &&
        size(data.sections) > 0 &&
        data.section_titles &&
        data.section_titles.map((section, section_id) => {
          const isLastIndex = section_id === data.section_titles.length - 1;
          return (
            <div
              // onClick={() => ClickOnPart(section.section_number)}
              key={section_id}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                position: "relative",
                cursor: "pointer"
              }}
            >
              <SectionBar
                section_number={section.section_number}
                standing_page={standing_page}
                data={data}
                answers={answers}
                section={section}
                isLastIndex={isLastIndex}
              />
            </div>
          );
        })}
    </div>
  );
};

export default Sidebar;
